module.exports = __webpack_public_path__ + "static/bearbath1-9e3a1cac923e0e17cfa100b1612db375.png";